import { Project } from "interfaces";

import * as flowConfig from "flows/time-series/config";
import { projectIsTimeSeriesAnalysis } from "flows/time-series/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsTimeSeriesAnalysis(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p>
        Time-series are based on{" "}
        <span className="italic underline">
          {project.meta_data[flowConfig.TIMESTAMP_VAR]}
        </span>
        .
      </p>
    </div>
  );
};

export default ContextSummary;
